// extracted by mini-css-extract-plugin
module.exports = {"spinnerDiv":"style_spinnerDiv__329vY","spinner":"style_spinner__3Gpfp","dottedDiv":"style_dottedDiv__2gH2i","dotted":"style_dotted__14XTA"};